import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

export const filterSchema: Schema = {
  type: {
    label: "Тип",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все типы", value: "" },
      { label: "Разовая покупка", value: "PPV" },
      { label: "Подписка", value: "SUBSCRIPTION" },
    ],
  },
  refunded: {
    label: "Возврат",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все", value: "" },
      { label: "Да", value: "true" },
      { label: "Нет", value: "false" },
    ],
  },
  disputed: {
    label: "Диспут",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все", value: "" },
      { label: "Да", value: "true" },
      { label: "Нет", value: "false" },
    ],
  },
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};

// refunded/disputed — Boolean-пути в ProductPurchaseModel; Mongoose кастует
// только ограниченный набор строк (true/false/1/0/yes/no) и падает
// CastError на любой другой ввод, что из-за non-null connection обнуляет весь
// список. Приводим строки select-фильтра к boolean и убираем пустые значения
// ("Все") явно, не полагаясь только на автоконверсию в CrudList.
const BOOLEAN_FILTER_KEYS = new Set(["refunded", "disputed"]);

export function normalizeProductPurchasesFilter(
  filter: Record<string, unknown>
): Record<string, unknown> {
  return Object.entries(filter).reduce<Record<string, unknown>>(
    (normalized, [key, value]) => {
      if (value === "" || value === null || value === undefined) {
        return normalized;
      }

      if (BOOLEAN_FILTER_KEYS.has(key) && typeof value === "string") {
        normalized[key] = value === "true";
        return normalized;
      }

      normalized[key] = value;
      return normalized;
    },
    {}
  );
}
